export default __webpack_public_path__ + "img/a678611c7f965c980a78aeea512b2e06.svg";